<script setup lang="ts">
import { AppButton } from '@libs/ui';

interface PaxSelectorButtonProps {
  buttonText: string;
}

const props = defineProps<PaxSelectorButtonProps>();

interface PaxSelectorButtonEmits {
  (eventName: 'click'): void;
}

const emit = defineEmits<PaxSelectorButtonEmits>();
</script>

<template>
  <AppButton
    type="modern"
    state="enabled"
    size="small"
    :left-icon="{
      size: '18',
      name: 'peopleOutlined',
    }"
    :right-icon="{
      size: '18',
      name: 'chevronDown',
    }"
    @click="emit('click')"
  >
    {{ props.buttonText }}
  </AppButton>
</template>
